<template>
  <div class="product-review">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">商品标题：</span>
            <el-input v-model="searchInfo.title" clearable placeholder="请输入商品标题"></el-input>
          </div>
          <div class="search-item">
            <span class="label">商品状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">商品分类：</span>
            <el-select v-model="searchInfo.categoryId" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in categoryList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">省份：</span>
            <el-input v-model="searchInfo.province" clearable placeholder="请输入省份"></el-input>
          </div>
          <div class="search-item">
            <span class="label">城市：</span>
            <el-input v-model="searchInfo.city" clearable placeholder="请输入城市"></el-input>
          </div>
          <div class="search-item">
            <span class="label">新旧程度：</span>
            <el-select v-model="searchInfo.condition" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in conditionList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">用户名称：</span>
            <el-input v-model="searchInfo.nickname" clearable placeholder="请输入用户名称"></el-input>
          </div>
          <div class="search-item">
            <span class="label">用户号码：</span>
            <el-input v-model="searchInfo.phone" clearable placeholder="请输入用户号码"></el-input>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="showAddDialog" v-if="$can('product:add')">新增商品</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="coverImage" label="商品图片" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.coverImage" style="position: relative; display: inline-block;">
              <el-image
                :src="parseImages(scope.row.coverImage)[0]"
                :preview-src-list="parseImages(scope.row.coverImage)"
                style="width: 60px; height: 60px; border-radius: 4px;"
                fit="cover"
              />
              <span v-if="parseImages(scope.row.coverImage).length > 1"
                    style="position: absolute; bottom: 2px; right: 2px; background: rgba(0,0,0,0.6); color: #fff; padding: 0 4px; font-size: 10px; border-radius: 2px;">
                {{ parseImages(scope.row.coverImage).length }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="商品标题" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryId" label="商品分类" width="120">
          <template slot-scope="scope">
            <span>{{ getCategoryText(scope.row.categoryId) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="售价" width="100">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: 500;">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="originalPrice" label="原价" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.originalPrice" style="text-decoration: line-through; color: #999;">¥{{ scope.row.originalPrice }}</span>
            <span v-else style="text-decoration: line-through; color: #999;">--</span>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="用户名称" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showUserDetail(scope.row)">{{ scope.row.nickname }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="用户帐号" width="120">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="reviewStatus" label="审核" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType1(scope.row.reviewStatus)">
              {{ getStatusText1(scope.row.reviewStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="地区" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.province }} {{ scope.row.city }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="condition" label="新旧程度" width="100">
          <template slot-scope="scope">
            <span>{{ getConditionText(scope.row.condition) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="viewCount" label="浏览量" width="80">
          <template slot-scope="scope">
            <span style="color: #409EFF;">{{ scope.row.viewCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shippingMethod" label="发货方式" width="100">
          <template slot-scope="scope">
            <span>{{ getShippingMethodText(scope.row.shippingMethod) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="110">
          <template slot-scope="scope">
            <el-button type="text" size="small"  @click="viewDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small"  @click="reviewProduct(scope.row)">审核</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 商品详情弹窗 -->
    <product-detail-dialog
      :visible.sync="productDetailVisible"
      :product-id="selectedProductId">
    </product-detail-dialog>

    <!-- 商品编辑/新增弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="productDialogVisible"
      width="800px"
      :before-close="handleFormClose">
      <el-form :model="productForm" :rules="formRules" ref="productForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商品标题" prop="title">
              <el-input v-model="productForm.title" placeholder="请输入商品标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品分类" prop="categoryId">
              <el-select v-model="productForm.categoryId" placeholder="请选择商品分类" style="width: 100%;">
                <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="售价" prop="price">
              <el-input-number v-model="productForm.price" :precision="2" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价">
              <el-input-number v-model="productForm.originalPrice" :precision="2" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="新旧程度" prop="condition">
              <el-select v-model="productForm.condition" style="width: 100%;">
                <el-option v-for="item in conditionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品状态">
              <el-select v-model="productForm.status" style="width: 100%;">
                <el-option label="未审核" :value="0"></el-option>
                <el-option label="草稿" :value="1"></el-option>
                <el-option label="已上架" :value="2"></el-option>
                <el-option label="已下架" :value="3"></el-option>
                <el-option label="已售出" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品描述">
          <el-input v-model="productForm.description" type="textarea" :rows="3" placeholder="请输入商品描述"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="省份" prop="province">
              <el-input v-model="productForm.province" placeholder="请输入省份"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="城市" prop="city">
              <el-input v-model="productForm.city" placeholder="请输入城市"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="区县">
              <el-input v-model="productForm.district" placeholder="请输入区县"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="发货方式">
          <el-select v-model="productForm.shippingMethod" style="width: 100%;">
            <el-option label="邮寄" :value="1"></el-option>
            <el-option label="面交" :value="2"></el-option>
            <el-option label="都可以" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品封面图">
          <el-input v-model="productForm.coverImage" placeholder="请输入商品封面图URL"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="productDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitProduct" :loading="saving">保存</el-button>
      </div>
    </el-dialog>

    <!-- 商品审核弹窗 -->
    <el-dialog
      title="商品审核"
      :visible.sync="reviewDialogVisible"
      width="500px"
      :before-close="handleReviewClose">
      <el-form :model="reviewForm" :rules="reviewRules" ref="reviewForm" label-width="100px">
        <el-form-item label="审核状态" prop="reviewStatus">
          <el-radio-group v-model="reviewForm.reviewStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">未通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="msg">
          <el-input
            v-model="reviewForm.msg"
            type="textarea"
            :rows="4"
            placeholder="请输入审核备注（未通过时必填）"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="reviewDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReview" :loading="reviewSubmitting">提交</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情对话框 -->
    <user-detail-dialog
      :visible.sync="userDetailVisible"
      :user-id="selectedUserId">
    </user-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';
  import ProductDetailDialog from '../common/product-detail-dialog.vue';

  export default {
    name: "product-review",
    components: {
      UserDetailDialog,
      ProductDetailDialog
    },
    data () {
      return {
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        saving: false,
        // 弹窗控制
        productDetailVisible: false,
        productDialogVisible: false,
        selectedProductId: null,
        dialogTitle: '新增商品',
        isEdit: false,
        // 审核弹窗
        reviewDialogVisible: false,
        reviewSubmitting: false,
        reviewForm: {
          productId: null,
          reviewStatus: 1,
          msg: ''
        },
        // 用户详情弹窗
        userDetailVisible: false,
        selectedUserId: null,
        // 商品表单
        productForm: {
          id: null,
          title: '',
          description: '',
          price: null,
          originalPrice: null,
          categoryId: '',
          coverImage: '',
          condition: 1,
          province: '',
          city: '',
          district: '',
          shippingMethod: 1,
          status: 2
        },
        // 搜索条件
        searchInfo: {
          title: '',
          status: '',
          categoryId: '',
          province: '',
          city: '',
          condition: '',
          nickname: '',
          phone: '',
          startDate: '',
          endDate: '',
          pageNumber: 1,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '草稿', value: 1 },
          { label: '已上架', value: 2 },
          { label: '已下架', value: 3 },
          { label: '已售出', value: 4 }
        ],
        categoryList: [
          { label: '引擎配件', value: 1 },
          { label: '车身配件', value: 2 },
          { label: '底盘配件', value: 3 },
          { label: '电气配件', value: 4 },
          { label: '其他', value: 5 }
        ],
        conditionList: [
          { label: '全新', value: 1 },
          { label: '99新', value: 2 },
          { label: '95新', value: 3 },
          { label: '9成新', value: 4 },
          { label: '其他', value: 5 }
        ],
        // 表单验证规则
        formRules: {
          title: [
            { required: true, message: '请输入商品标题', trigger: 'blur' }
          ],
          categoryId: [
            { required: true, message: '请选择商品分类', trigger: 'change' }
          ],
          price: [
            { required: true, message: '请输入商品价格', trigger: 'blur' }
          ],
          condition: [
            { required: true, message: '请选择新旧程度', trigger: 'change' }
          ],
          province: [
            { required: true, message: '请输入省份', trigger: 'blur' }
          ],
          city: [
            { required: true, message: '请输入城市', trigger: 'blur' }
          ]
        },
        // 审核表单验证规则
        reviewRules: {
          reviewStatus: [
            { required: true, message: '请选择审核状态', trigger: 'change' }
          ],
          msg: [
            {
              validator: (rule, value, callback) => {
                if (this.reviewForm.reviewStatus === 2 && !value) {
                  callback(new Error('未通过时必须填写审核备注'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.title'(newVal){
        if (newVal === ""){
          this.getProductList();
        }
      },
      'searchInfo.nickname'(newVal){
        if (newVal === ""){
          this.getProductList();
        }
      },
      'searchInfo.phone'(newVal){
        if (newVal === ""){
          this.getProductList();
        }
      },
      'searchDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getProductList();
        }
      },
    },
    created() {
      this.getProductList();
    },
    methods: {
      // 显示用户详情
      showUserDetail(row) {
        this.selectedUserId = row.userId;
        this.userDetailVisible = true;
      },

      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 1;
        this.getProductList();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val;
        this.getProductList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 1;
        this.getProductList();
      },
      showApprovalStatus(val){
        // 0:未提交 1:未审核 2:审核通过 3：审批退回 4:已关闭
        if (val == 4){
            return "已完结";
        }else if (val == 3){
            return "审批退回";
        } else if (val == 2){
            return "审核通过";
        } else{
            return "未审核";
        }
      },
      // 获取商品列表
      getProductList() {
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }

        if (this.loading) return;
        this.loading = true;

        axios.get('/admin/product/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },


      // 查看商品详情
      viewDetail(row) {
        this.selectedProductId = row.id;
        this.productDetailVisible = true;
      },

      // 显示新增对话框
      showAddDialog() {
        this.dialogTitle = '新增商品';
        this.isEdit = false;
        this.resetForm();
        this.productDialogVisible = true;
      },

      // 审核商品
      reviewProduct(row) {
        this.reviewForm = {
          productId: row.id,
          reviewStatus: 1,
          msg: ''
        };
        this.reviewDialogVisible = true;
      },

      // 提交审核
      submitReview() {
        this.$refs.reviewForm.validate((valid) => {
          if (valid) {
            this.reviewSubmitting = true;

            axios.put(`/admin/product/${this.reviewForm.productId}/review`, null, {
              params: {
                reviewStatus: this.reviewForm.reviewStatus,
                msg: this.reviewForm.msg
              }
            }).then(result => {
              this.reviewSubmitting = false;
              if (result.code === 200) {
                this.$message.success('审核成功');
                this.reviewDialogVisible = false;
                this.getProductList();
              } else {
                this.$message.error(result.message || '审核失败');
              }
            }).catch(err => {
              console.error(err);
              this.reviewSubmitting = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },
      getCategoryText(categoryId) {
        const categoryMap = {
          1: '引擎配件',
          2: '车身配件',
          3: '底盘配件',
          4: '电气配件',
          5: '其他'
        };
        return categoryMap[categoryId] || '未知';
      },
      // 关闭审核弹窗
      handleReviewClose(done) {
        this.reviewForm = {
          productId: null,
          reviewStatus: 1,
          msg: ''
        };
        if (this.$refs.reviewForm) {
          this.$refs.reviewForm.clearValidate();
        }
        done();
      },

      // 保存商品
      submitProduct() {
        this.$refs.productForm.validate((valid) => {
          if (valid) {
            this.saving = true;
            const url = this.isEdit ? `/admin/product/${this.productForm.id}` : '/admin/product';
            const method = this.isEdit ? 'put' : 'post';

            axios[method](url, this.productForm).then(result => {
              this.saving = false;
              if (result.code === 200) {
                this.$message.success(this.isEdit ? '更新成功' : '添加成功');
                this.productDialogVisible = false;
                this.getProductList();
              } else {
                this.$message.error(result.message || '操作失败');
              }
            }).catch(err => {
              console.error(err);
              this.saving = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 更改商品状态
      changeStatus(row) {
        const newStatus = row.status === 2 ? 3 : 2;
        const operation = newStatus === 2 ? '上架' : '下架';

        this.$confirm(`确定要${operation}商品"${row.title}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.put(`/admin/product/${row.id}/status`, {
            status: newStatus
          }).then(result => {
            if (result.code === 200) {
              this.$message.success(`${operation}成功`);
              this.getProductList();
            } else {
              this.$message.error(result.message || `${operation}失败`);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('网络异常，请重试');
          });
        }).catch(() => {
          this.$message.info(`已取消${operation}`);
        });
      },

      // 删除商品
      confirmDelete(row) {
        this.$confirm(`确定要删除商品"${row.title}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteProduct(row.id);
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      deleteProduct(id) {
        axios.delete(`/admin/product/${id}`).then(result => {
          if (result.code === 200) {
            this.$message.success('删除成功');
            this.getProductList();
          } else {
            this.$message.error(result.message || '删除失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleFormClose(done) {
        this.resetForm();
        done();
      },

      // 重置表单
      resetForm() {
        this.productForm = {
          id: null,
          title: '',
          description: '',
          price: null,
          originalPrice: null,
          categoryId: '',
          coverImage: '',
          condition: 1,
          province: '',
          city: '',
          district: '',
          shippingMethod: 1,
          status: 2
        };
        if (this.$refs.productForm) {
          this.$refs.productForm.clearValidate();
        }
      },

      // 工具方法
      getStatusText(status) {
        const statusMap = {
          0: '未审核',
          1: '草稿',
          2: '已上架',
          3: '已下架',
          4: '已售出'
        };
        return statusMap[status] || '未知';
      },
      // 工具方法
      getStatusText1(status) {
        const statusMap = {
          0: '未审核',
          1: '审核通过',
          2: '未通过'
        };
        return statusMap[status] || '未知';
      },
      getStatusTagType(status) {
        const typeMap = {
          0: 'warning',  // 未审核
          1: 'info',     // 草稿
          2: 'success',  // 已上架
          3: 'danger',   // 已下架
          4: 'primary'   // 已售出
        };
        return typeMap[status] || 'info';
      },
      getStatusTagType1(status) {
        const typeMap = {
          2: 'warning',  // 未审核
          1: 'success',     // 草稿
          0: 'info'
        };
        return typeMap[status] || 'info';
      },

      getConditionText(condition) {
        const conditionMap = {
          1: '全新',
          2: '99新',
          3: '95新',
          4: '9成新',
          5: '其他'
        };
        return conditionMap[condition] || '未知';
      },

      getCategoryText(categoryId) {
        const categoryMap = {
          1: '引擎配件',
          2: '车身配件',
          3: '底盘配件',
          4: '电气配件',
          5: '其他'
        };
        return categoryMap[categoryId] || '未知';
      },

      getShippingMethodText(method) {
        const methodMap = {
          1: '邮寄',
          2: '面交',
          3: '都可以'
        };
        return methodMap[method] || '未知';
      },

      // 解析图片URL（分号分隔）
      parseImages(coverImage) {
        if (!coverImage) return [];
        // 分号分隔，过滤空字符串
        return coverImage.split(';').filter(img => img.trim());
      }

    }
  }
</script>
<style lang="less" scoped>
  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  /deep/ .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-table .warning-row {
    background: #fdf6ec;
  }

  /deep/ .el-table .danger-row {
    background: #fef0f0;
  }
</style>
